import { type ModalId } from '@heidi/schema/ml-scribe';

export const COMPLIMENTARY_TRIAL_ENDED_MODAL_ID =
  'T3_CUSTOM_AUDIENCE_HEIDI_2_TRIAL_ENDED_MODAL' as ModalId;
